/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['./json', './jsonp'], function(json, jsonp) {
    'use strict';
    var useJsonp = false;
    var useHttp = false;

    return {
        useJsonp: function(use) {
            useJsonp = use;
        },

        useHttp: function(use) {
            useHttp = use;
        },

        protocol: function() {
            return useHttp ? 'http' : 'https';
        },

        get: function(options) {
            options.protocol = options.protocol || this.protocol();
            return useJsonp ? jsonp.get(options) : json.get(options);
        },

        post: function(options) {
            if (useJsonp) {
                console.warn('Jsonp is not supported, using json request.');
            }
            options.protocol = options.protocol || this.protocol();
            return json.post(options);
        }
    };
});



// WEBPACK FOOTER //
// ./requester/requester.js